<div class="cout-portion" *ngIf="displayPrixAchat"  >

  <span *ngIf="!this.utils.isCollectionNullOrEmpty(menuComposition.udpPdErreurs) || utils.isNullOrEmpty(menuComposition.udpPdPrixAchat) ">
    <i class="fas fa-exclamation-triangle danger-color cursor mg-r-5" [title]="getErreurs(menuComposition)" ></i>
  </span>
  <span class="mg-r-5" *ngIf="!utils.isNullOrEmpty(menuComposition.udpPdPrixAchat) ">{{menuComposition.udpPdPrixAchat | currency:'EUR':'symbol':'1.4-4'}}</span>

</div>
